/* AI相談/診断 v2: モバイルでステーション02/03を折りたたみ
   (game-search-section の v2_style=true 時のみ読込)
   - 折りたたみclassはロード後に付与 (既存init干渉回避)
   - DOM移動なし・既存id/class/data属性の変更なし */
(function(){
  var root = document.getElementById('WzApp');
  if (!root) return;
  var mq = window.matchMedia('(max-width: 768px)');
  /* 折りたたみ対象: 02 画質と動き(comfort) / 03 主な用途(usage)。
     01は最初の入力なので開、04はCTAを内包するため開。 */
  var targets = ['comfort', 'usage'].map(function(key){
    return root.querySelector('.gs-station[data-station="' + key + '"]');
  }).filter(Boolean);
  if (!targets.length) return;

  function setCollapsed(st, collapsed){
    st.classList.toggle('tgv2-collapsed', collapsed);
    var head = st.querySelector('.gs-station__head');
    if (head) head.setAttribute('aria-expanded', collapsed ? 'false' : 'true');
  }

  function disableStation(st){
    st.classList.remove('tgv2-collapsible');
    setCollapsed(st, false);
    var head = st.querySelector('.gs-station__head');
    if (!head) return;
    head.removeAttribute('role');
    head.removeAttribute('tabindex');
    head.removeAttribute('aria-expanded');
    head.removeEventListener('click', onToggle);
    head.removeEventListener('keydown', onKey);
  }

  function enable(){
    targets.forEach(function(st){
      /* 1画面1問の新ウィザードは、現在の設問を常に開いたままにする。 */
      if (st.closest('.gs-wiz__window')){
        disableStation(st);
        return;
      }
      if (st.classList.contains('tgv2-collapsible')) return;
      st.classList.add('tgv2-collapsible');
      var head = st.querySelector('.gs-station__head');
      if (!head) return;
      head.setAttribute('role', 'button');
      head.setAttribute('tabindex', '0');
      head.addEventListener('click', onToggle);
      head.addEventListener('keydown', onKey);
      setCollapsed(st, true);
    });
  }
  function disable(){
    targets.forEach(disableStation);
  }
  function onToggle(e){
    e.stopPropagation();
    if (!mq.matches) return;
    var st = e.currentTarget.closest('.gs-station');
    if (st) setCollapsed(st, !st.classList.contains('tgv2-collapsed'));
  }
  function onKey(e){
    if (e.key !== 'Enter' && e.key !== ' ') return;
    e.preventDefault();
    onToggle(e);
  }
  function sync(){
    if (mq.matches) enable(); else disable();
  }

  /* 既存initが終わってから折りたたむ (ロード直後のdisplay:noneを避ける) */
  if (document.readyState === 'loading'){
    document.addEventListener('DOMContentLoaded', function(){
      requestAnimationFrame(sync);
    });
  } else {
    requestAnimationFrame(sync);
  }
  if (mq.addEventListener) mq.addEventListener('change', sync);
  else if (mq.addListener) mq.addListener(sync);
})();
